import React, { useState, ReactNode } from 'react';

import { Button, Modal, SemanticICONS } from 'semantic-ui-react';
import { t } from '../../locales/i18n';
import styled from 'styled-components';

import { Icon } from '../icon';
import { sizes } from '../../themes/sizes';
import { SemanticSIZES } from 'semantic-ui-react/dist/commonjs/generic';

interface DialogContentProps {
  disabled?: boolean;
  confirmDisabled?: boolean;
  primary?: boolean;
  label?: string;
  onConfirm: () => void;
  title: string;
  subtitle?: string;
  children?: ReactNode;
}

interface ConfirmButtonProps extends DialogContentProps {
  disabled?: boolean;
  confirmDisabled?: boolean;
  primary?: boolean;
  negative?: boolean;
  size?: SemanticSIZES;
  basic?: boolean;
  label?: string;
  onConfirm: () => void;
  title: string;
  subtitle?: string;
  iconName?: SemanticICONS;
  children?: ReactNode;
}

const DialogContainer = styled.section`
  display: grid;
  grid-template-rows: max-content 1fr max-content;
  grid-gap: ${sizes.margins.large};
  padding: ${sizes.margins.huge};
`;

const DialogTitle = styled.h4``;
const DialogActions = styled.section`
  display: grid;
  justify-content: end;
  grid-auto-flow: column;
`;
const DialogContentSection = styled.section`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: ${sizes.margins.large};
  }
  h1,
  h2,
  h3 {
    font-size: ${sizes.fonts.large};
  }
  h4,
  h5,
  h6 {
    font-size: ${sizes.fonts.normal};
  }
`;

function DialogContent(props: DialogContentProps & { setOpen: (isOpen: boolean) => void }) {
  const { onConfirm, title, subtitle, confirmDisabled, children, setOpen } = props;
  return (
    <DialogContainer>
      <DialogTitle>{title}</DialogTitle>
      <DialogContentSection>
        <h6>{subtitle}</h6>
        <div>{children}</div>
      </DialogContentSection>
      <DialogActions>
        <Button basic onClick={() => setOpen(false)}>
          {t('button.cancel')}
        </Button>
        <Button
          primary
          disabled={confirmDisabled}
          onClick={() => {
            onConfirm();
            setOpen(false);
          }}
        >
          {t('button.ok')}
        </Button>
      </DialogActions>
    </DialogContainer>
  );
}

export function ConfirmButton(props: ConfirmButtonProps) {
  const { iconName, disabled, label, basic, primary, size, negative } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isOpen, setOpen] = useState(false);
  return (
    <Modal
      open={isOpen}
      trigger={
        <Button
          negative={negative}
          size={size}
          basic={basic}
          primary={primary}
          disabled={disabled}
          onClick={() => setOpen(true)}
        >
          {iconName && <Icon name={iconName} />}
          {label && <span>{label}</span>}
        </Button>
      }
    >
      <DialogContent {...props} setOpen={setOpen} />
    </Modal>
  );
}

export function ConfirmIcon(props: ConfirmButtonProps) {
  const { iconName, label } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isOpen, setOpen] = useState(false);
  return (
    <Modal
      open={isOpen}
      trigger={
        <a style={{ cursor: 'pointer' }} onClick={() => setOpen(true)}>
          {iconName && <Icon name={iconName} />}
          {label && <span>{label}</span>}
        </a>
      }
    >
      <DialogContent {...props} setOpen={setOpen} />
    </Modal>
  );
}
